import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { RootState } from "../../../../app/store";
import Localized from "../../../../Localized";
import { useUpdateProductsMutation, useSendContactInfoMutation } from "../../../../redux/api";
import { isButtonLoader } from "../../../../redux/slices/windowSlice";
import './style.scss';

const ButtonFooter = () => {
    const dispatch = useAppDispatch();
    const { stepCurrent, loaderButton } = useAppSelector((state: RootState) => state.windowSlice);
    const { totalCount, isPaymentPromo, goods } = useAppSelector((state: RootState) => state.orderSlice);
    const { mail, isMailValid } = useAppSelector((state: RootState) => state.userSlice);
    const [ sendCart ] = useUpdateProductsMutation();
    const [ sendContact ] = useSendContactInfoMutation();

    const handleChange = () => {
        if(!loaderButton) {
            switch (stepCurrent) {
                case 0:
                case 1:
                
                    dispatch(isButtonLoader(true));
                    const cartData = new FormData();
                    cartData.append('cart', JSON.stringify(
                        goods.map((item) => {
                            return {
                                id: item.categoryId,
                                count: item.count,
                                isPromo: item.isActivatePromo
                            };
                        })
                    ));
        
                    sendCart(cartData);
                    break;
    
                case 2:
                    if(isMailValid) {
                        dispatch(isButtonLoader(true));
                        const contactData = new FormData();
                        contactData.append('email', mail);
                        contactData.append('lang', 'ru');
                        
                        sendContact(contactData);
                    } else {
    
                    }
                    
                    break;
            }
        }
    }

    const getBtnText = () => {
        if(totalCount===0) {
            return Localized.BtnOrderEmpty;
        }
        switch (stepCurrent) {
            case 0:
                return Localized.BtnLookOrder;
            case 1:
                return Localized.BtnPlaceOrder;
            case 2:
                return Localized.BtnPayOrder;    
        }
    }

    const getClassButton = () => {
        if(isPaymentPromo) {
            if ((stepCurrent>0 && totalCount===0) || (!isMailValid && stepCurrent===2)) {
                return 'button-footer button-footer_empty'; 
            } else {
                return 'button-footer button-footer_promo';
            }
        } else {
            if ((stepCurrent>0 && totalCount===0) || (!isMailValid && stepCurrent===2)) {
                return 'button-footer button-footer_empty'; 
            } else {
                return 'button-footer button-footer_simple';
            }
        }
    }
    return (
        <div className={getClassButton()} style={totalCount > 0 || stepCurrent > 0 ? {transform: 'translateY(0)'} : {}}>
            <div className="button-footer_container">
                <div className="button-footer_wrapper" onClick={()=>{handleChange()}}>
                    <div className="loader" style={loaderButton ? {display: 'block'}: {display: 'none'}}></div>
                    <span className="button-footer_text" style={!loaderButton ? {display: 'block'}: {display: 'none'}}>{getBtnText()}</span>
                </div>
            </div>
        </div>
    );
}

export default ButtonFooter;